import React from 'react'
import Button from '../templates/Button'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Home } from 'iconoir-react'

const NotFoundPage = () => {
  const navigator = useNavigate();

  return (
    <div className='min-h-screen w-full flex items-center justify-center bg-surface-50 relative overflow-hidden'>
      {/* Background decorations */}
      <div className="absolute inset-0 bg-hero-pattern opacity-50" />
      <div className="absolute top-20 left-20 w-72 h-72 bg-primary-200/30 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent-200/30 rounded-full blur-3xl" />

      {/* Content */}
      <div className='relative z-10 text-center px-6'>
        {/* 404 Number */}
        <div className='relative inline-block mb-8'>
          <span className='text-[180px] font-black text-transparent bg-clip-text bg-gradient-to-br from-primary-200 to-primary-300 leading-none select-none'>
            404
          </span>
          <div className='absolute inset-0 flex items-center justify-center'>
            <div className='w-32 h-32 rounded-full bg-white shadow-soft-xl flex items-center justify-center'>
              <span className='text-6xl'>🚗</span>
            </div>
          </div>
        </div>

        {/* Message */}
        <div className='max-w-md mx-auto'>
          <h1 className='text-3xl font-bold text-surface-800 mb-3'>
            Oops! Page Not Found
          </h1>
          <p className='text-surface-500 mb-8'>
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>

          {/* Actions */}
          <div className='flex flex-col sm:flex-row items-center justify-center gap-3'>
            <Button
              onClick={() => navigator(-1)}
              label='Go Back'
              icon={<ArrowLeft strokeWidth={2} className='w-5 h-5' />}
              iconPosition='left'
              variant='secondary'
            />
            <Button
              onClick={() => navigator('/analytics')}
              label='Go to Dashboard'
              icon={<Home strokeWidth={2} className='w-5 h-5' />}
              iconPosition='left'
              variant='primary'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
